/**
 * Normalizes the deposit configs API response to an array.
 * Handles both direct array and wrapped shapes (e.g. { deposit_configs: [...] }).
 */
export function normalizeDepositConfigsResponse(response: unknown): unknown[] {
  if (Array.isArray(response)) return response;
  if (response && typeof response === "object") {
    const obj = response as Record<string, unknown>;
    if (Array.isArray(obj.deposit_configs)) return obj.deposit_configs;
    if (Array.isArray(obj.data)) return obj.data;
    if (Array.isArray(obj.items)) return obj.items;
  }
  return [];
}
